import type { ProfessionFaqItem } from './types'

/** Respostas que se repetem entre as profissões, para dizer sempre a mesma coisa do mesmo jeito. */
export const faqProgramar: ProfessionFaqItem = {
  question: 'Preciso saber programar?',
  answer: 'Não. Você descreve a tarefa em português, do jeito que falaria para um colega, e confere o que saiu. A parte técnica fica com a ferramenta.',
}

export const faqCusto: ProfessionFaqItem = {
  question: 'Quanto custa aprender isso comigo?',
  answer: 'A primeira conversa de 30 minutos é gratuita. Você sai com um primeiro passo para tentar sozinho. Se quiser continuar, o valor do acompanhamento individual é combinado na conversa. O canal também é gratuito.',
}

export const faqCelular: ProfessionFaqItem = {
  question: 'Uso mais o celular do que o computador. Serve?',
  answer: 'O celular pode ajudar a fotografar um papel ou reunir um exemplo. A primeira conversa e o acompanhamento acontecem no computador, por videochamada. A ferramenta depende do seu caso.',
}

export const faqComputadorDaEmpresa: ProfessionFaqItem = {
  question: 'Posso usar no computador da empresa?',
  answer: 'Depende das regras do lugar onde você trabalha. Combine quais ferramentas e informações pode usar com quem cuida disso. A escolha da ferramenta e a necessidade de instalação dependem da tarefa.',
}

export const faqSistema = (sistema: string): ProfessionFaqItem => ({
  question: `Funciona com o meu ${sistema}?`,
  answer: `As tarefas desta página acontecem nos arquivos que você exporta ou copia para uma pasta: planilhas, documentos, fotos. O ${sistema} continua o mesmo; a IA trabalha no que sai dele.`,
})

export const faqDados = (deQuem: string): ProfessionFaqItem => ({
  question: `E os dados ${deQuem}?`,
  answer: `Antes de compartilhar dados ${deQuem}, leia os termos da ferramenta que escolher e combine com quem responde pelo lugar onde você trabalha quais informações podem ser usadas. O que a IA acessa depende da ferramenta e das permissões escolhidas.`,
})

export const passoGuardarPadrao = 'Salve o seu pedido num arquivo de texto, dentro da mesma pasta.'
